import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import GeneralNavbar from './GeneralNavbar'; // 👈 Importación del navbar
import './UploadProductExcel.css';

const UploadProductExcel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate(); // 👈 Para manejar la navegación

  const handleBackClick = () => {
    navigate(-1); // 👈 Volver a la página anterior
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      setIsLoading(true);

      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet);

      for (const row of rows) {
       const {
        docId,
        name,
        description,
        category,
        price,
        stock,
        discount,
        discountInPesos,
        enabled,
        id,
        image
      } = row;


        if (!docId) continue;

        try {
          await updateDoc(doc(db, 'products', docId), {
          name: name || '',
          description: description || '',
          category: category || '',
          price: Number(price),
          stock: Number(stock),
          discount: Number(discount),
          discountInPesos: Number(discountInPesos) || 0,
          enabled: enabled === 'Sí' || enabled === true,
          id: Number(id),
          image: image || ''
        });

          console.log(`✅ Actualizado: ${docId}`);
        } catch (error) {
          console.error(`❌ Error actualizando ${docId}:`, error);
        }
      }

      setIsLoading(false);
      alert('📦 Productos actualizados correctamente desde Excel');
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="upload-excel-container">
      {/* 👇 Navbar con título y botón atrás */}
      <GeneralNavbar title="Actualizar Productos" onBackClick={handleBackClick} />

      <h3>Subir archivo Excel (.xlsx)</h3>
      <input type="file" accept=".xlsx" onChange={handleFileUpload} />

      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p className="loading-message">Actualizando productos, por favor espera...</p>
        </div>
      )}
    </div>
  );
};

export default UploadProductExcel;


